import request from './../../utilities/request';
import localStorageToken from './../../utilities/storage';

function get(page) {
  return request({
    url:    `/alert/list/page/${ page }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function create(values) {
  return request({
    url:    '/alert/save',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
}

function update(id, values) {
  return request({
    url:    `/alert/update/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'PUT',
    data:   values
  });
}

function find(id) {
  return request({
    url:    `/alert/overview/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function remove(id) {
  return request({
    url:    `/alert/remove/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'DELETE'
  });
}

const AlertService = {
  get, create, update, remove, find
}

export default AlertService;
